import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import { useLoginForm } from "./useLoginForm";
import { useLoginBanner } from "./useLoginBanner";
import { LOGIN_CAROUSEL_ITEMS } from "./loginCarouselData";

export const useLoginPage = () => {
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [errorModalMessage, setErrorModalMessage] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const { login, loading } = useAuth();

    const {
        dni,
        password,
        helperText,
        handleDniChange,
        handlePasswordChange,
        tiempoBloqueo,
        registrarIntentoFallido,
        intentosRestantes,
    } = useLoginForm();

    const {
        bannerIndex,
        fade,
        goToSlide,
    } = useLoginBanner(LOGIN_CAROUSEL_ITEMS.length);

    const activeBannerItem = LOGIN_CAROUSEL_ITEMS[bannerIndex] || null;

    const from =
        location.state?.from?.pathname && location.state.from.pathname !== "/"
            ? location.state.from.pathname
            : "/";

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Si ya está bloqueado o el DNI está incompleto, no hacemos nada
        if (tiempoBloqueo > 0 || dni.length !== 8 || !password.trim()) return;

        const loginResult = await login(dni, password);

        if (loginResult?.authenticated) {
            navigate(from, { replace: true });
            return;
        }

        setErrorModalMessage(
            loginResult?.errorMessage ||
            "No hemos podido validar tus credenciales. Verifica tus datos e inténtalo nuevamente."
        );
        setErrorModalOpen(true);
        if (loginResult?.statusCode === 401 && registrarIntentoFallido) {
            registrarIntentoFallido();
        }
    };

    const closeErrorModal = () => {
        setErrorModalOpen(false);
    };

    return {
        dni,
        password,
        loading,
        helperText,
        handleDniChange,
        handlePasswordChange,
        tiempoBloqueo,
        bannerItems: LOGIN_CAROUSEL_ITEMS,
        activeBannerItem,
        bannerIndex,
        fade,
        goToSlide,
        errorModalOpen,
        errorModalMessage,
        closeErrorModal,
        handleSubmit,
        intentosRestantes,
    };
};
